import { transition, trigger, useAnimation } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { notify } from 'app/store/common-effects/notifier.effects';
import { reloadableRequest } from 'core/utils/reloadable-request';
import { ClipboardService } from 'ngx-clipboard';
import { Observable, Subject } from 'rxjs';
import { hideAnimation, showAnimation } from 'shared/common/animations';

@Component({
  selector: 'app-summary-dialog',
  templateUrl: './summary-dialog.component.html',
  styleUrls: ['./summary-dialog.component.scss'],
  animations: [
    trigger('show', [
      transition('void => *', [
        useAnimation(showAnimation),
      ]),
    ]),
    trigger('hide', [
      transition('* => void', [
        useAnimation(hideAnimation),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SummaryDialogComponent {
  readonly reload = new Subject<void>();
  readonly requestStatus = { loading: false, failed: false };
  readonly html$: Observable<string>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: () => Observable<string>,
    private clipboard: ClipboardService,
    private store$: Store,
    private cd: ChangeDetectorRef,
  ) {
    this.html$ = reloadableRequest(data, this.reload, this.requestStatus, () => this.cd.markForCheck());
  }

  copyToClipboard(content: string): void {
    this.clipboard.copy(content);
    this.store$.dispatch(notify({ message: 'NOTIFICATIONS.text_copied' }));
  }
}
